import React from "react";

const HisFileSearch = ({ color, sx = {} }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg
      style={_sx}
      stroke={color}
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.207 2.51562H6.70703C6.1766 2.51563 5.66789 2.72634 5.29282 3.10141C4.91774 3.47648 4.70703 3.98519 4.70703 4.51562V20.5156C4.70703 21.0461 4.91774 21.5548 5.29282 21.9298C5.66789 22.3049 6.1766 22.5156 6.70703 22.5156H18.707C19.2375 22.5156 19.7462 22.3049 20.1212 21.9298C20.4963 21.5548 20.707 21.0461 20.707 20.5156V8.01562L15.207 2.51562Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.707 2.51562V8.51562H20.707"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.207 17.5156C13.5877 17.5156 14.707 16.3963 14.707 15.0156C14.707 13.6349 13.5877 12.5156 12.207 12.5156C10.8263 12.5156 9.70703 13.6349 9.70703 15.0156C9.70703 16.3963 10.8263 17.5156 12.207 17.5156Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.957 16.7656L15.707 18.5156"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisFileSearch;
